var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "large-12" }, [
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-12 columns" }, [
        _c("h3", [_vm._v("Stichtag")]),
        _vm._v(" "),
        !_vm.showStyle
          ? _c(
              "div",
              { staticClass: "spv-select-group flex-no-wrap row" },
              _vm._l(_vm.deadlines, function(deadline_) {
                return _c(
                  "div",
                  {
                    key: deadline_.id,
                    staticClass: "small-6 medium-4 large-4 columns"
                  },
                  [
                    _c("div", { staticClass: "radio-input" }, [
                      _c("input", {
                        attrs: {
                          id: "trend-" + deadline_.id,
                          type: "radio",
                          name: "trend-deadline"
                        },
                        domProps: {
                          checked: _vm.deadline == deadline_.id,
                          value: deadline_.id
                        },
                        on: {
                          change: function($event) {
                            _vm.onChangeDeadline(deadline_.id)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          class: { checked: _vm.deadline == deadline_.id },
                          attrs: { for: "trend-" + deadline_.id }
                        },
                        [_c("p", [_vm._v(_vm._s(deadline_.name))])]
                      )
                    ])
                  ]
                )
              })
            )
          : _c("div", { staticClass: "spv-select-group" }, [
              _c("div", { staticClass: "small-12 medium-6 large-4" }, [
                _c(
                  "select",
                  {
                    staticClass: "spv-input-select",
                    domProps: { value: _vm.deadline },
                    on: {
                      change: function(e) {
                        return _vm.onChangeDeadline(e.target.value)
                      }
                    }
                  },
                  _vm._l(_vm.deadlines, function(deadline_) {
                    return _c(
                      "option",
                      { key: deadline_.id, domProps: { value: deadline_.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(deadline_.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                )
              ])
            ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-6 columns" }, [
        _c("h3", [_vm._v("Zeitraum")]),
        _vm._v(" "),
        _c("div", { staticClass: "large-8" }, [
          _c(
            "select",
            {
              staticClass: "spv-input-select",
              domProps: { value: _vm.year_ },
              on: {
                change: function(e) {
                  return _vm.onSelectYear(e.target.value)
                }
              }
            },
            _vm._l(_vm.trend_years[_vm.deadline], function(year) {
              return _c("option", { key: year, domProps: { value: year } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.deadline === 1
                        ? "Jun " + year + " - Mai " + (year + 1)
                        : "Dez " + year + " - Nov " + (year + 1)
                    ) +
                    "\n          "
                )
              ])
            })
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _c("div", { staticClass: "medium-12 large-12 columns" }, [
        _c("h1", [
          _vm._v(
            "Normierte Wertentwicklung TrendPortfolio Index " +
              _vm._s(_vm.deadlines[_vm.deadline - 1].name)
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "large-12 columns spv-chart-wrapper" },
          [
            _c("index-chart", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.deadline === 1,
                  expression: "deadline === 1"
                }
              ],
              attrs: {
                data: _vm.trend_chart_items[1],
                max: _vm.trend_chart_max[1],
                name: "TrendPortfolio Index",
                color: "#E81700"
              }
            }),
            _vm._v(" "),
            _c("index-chart", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.deadline === 2,
                  expression: "deadline === 2"
                }
              ],
              attrs: {
                data: _vm.trend_chart_items[2],
                max: _vm.trend_chart_max[2],
                name: "TrendPortfolio Index",
                color: "#E81700"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "spv-price-inquiry" }, [
              _c("b", { staticClass: "spv-price-inquiry__label" }, [
                _vm._v("Kursabfrage")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "spv-price-inquiry__date-picker" },
                [
                  _c("span", [_vm._v("Datum")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: {
                      min: _vm.trend_max_dates[_vm.deadline].min_date,
                      max: _vm.trend_max_dates[_vm.deadline].max_date,
                      value: _vm.inquiry_date
                    },
                    on: { select: _vm.onSelectInquiryDate }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "spv-price-inquiry__value" }, [
                !_vm.inquiry_valid && !_vm.inquiry_date
                  ? _c("span", { staticClass: "error-value" }, [
                      _vm._v(
                        "\n              Bitte wählen Sie ein Datum\n            "
                      )
                    ])
                  : _vm.inquiry_value === -1
                    ? _c("span", { staticClass: "error-value" }, [
                        _vm._v(
                          "\n              Für dieses Datum liegt kein Datensatz vor. Bitte wählen Sie ein anderes Datum aus\n            "
                        )
                      ])
                    : !!_vm.inquiry_value
                      ? _c("span", [
                          _vm._v("\n              TrendPortfolio Index  "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.inquiry_value) + " Punkte")
                          ])
                        ])
                      : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button button-small block",
                  on: { click: _vm.onGetInquiryValue }
                },
                [_vm._v("Anzeigen")]
              )
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm.trendConfigText
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.trendConfigText) } })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row wrapper-spacing" }, [
      _vm.details_data.index_values && _vm.details_data.index_values.length
        ? _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("h1", [
              _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
                _vm._v("\n          Monatliche\n          "),
                _c("div", { staticClass: "info-overlay" }, [
                  _vm._v("\n            Wertentwicklung\n            "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-overlay__text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.gloss_texts_trend[0]) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spv-info-wrapper text-only" }, [
                _vm._v(
                  "\n          TrendPortfolio Index " +
                    _vm._s(_vm.deadlines[_vm.deadline - 1].name) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
                _c("span", { staticClass: "text-normal" }, [
                  _vm._v("mit Zielvolatilität")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-overlay" }, [
                  _c("span", { staticClass: "text-normal" }, [
                    _vm._v(
                      _vm._s(_vm.formatPercent(_vm.details_data.target_vol, 2))
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-overlay__text" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.gloss_texts_trend[1]) +
                        "\n            "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "spv-table-wrapper" }, [
              _c(
                "table",
                {
                  staticClass:
                    "spv-product-table spv-index-table spv-index-table--trend"
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "medium-8 large-9" }, [
                        _vm._v("Indexstichtag"),
                        _c("br"),
                        _vm._v(
                          _vm._s(_vm.deadlines[_vm.deadline - 1].label) +
                            _vm._s(_vm.details_data.year)
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "medium-4 large-3" }, [
                        _c(
                          "div",
                          { staticClass: "spv-info-wrapper flex-wrapper" },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-overlay" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "info-overlay__text right-aligned"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.gloss_texts_trend[2]) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.details_data.index_values, function(
                      data,
                      index
                    ) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(_vm.formatDate(data.date)))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatMoney(data.index_value, 2)))
                        ])
                      ])
                    })
                  ),
                  _vm._v(" "),
                  _c("tfoot", [
                    _c("tr", [
                      _c("td", { staticClass: "td-padding" }, [
                        _c("div", { staticClass: "spv-info-wrapper" }, [
                          _vm._v(
                            "\n                  Jahresrendite\n                  "
                          ),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "info-overlay__text right-auto" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.gloss_texts_trend[3]) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPercent(_vm.details_data.yearly_yield, 2)
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("div", { staticClass: "spv-info-wrapper" }, [
                          _vm._v(
                            "\n                  Maßgebliche\n                  "
                          ),
                          _c("div", { staticClass: "info-overlay" }, [
                            _vm._v(
                              "\n                    Jahresrendite\n                    "
                            ),
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "info-overlay__text right-auto" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.gloss_texts_trend[4]) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.formatPercent(
                              _vm.details_data.decisive_yearly_yield,
                              2
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row pdf-button-wrapper d-flex" }, [
              _c("div", { staticClass: "small-6 columns text-left" }, [
                _vm.factsheet_path && _vm.factsheet_path[_vm.deadline]
                  ? _c(
                      "a",
                      {
                        staticClass: "button button-small",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.onDownloadFactsheet(
                              _vm.factsheet_path[_vm.deadline]
                            )
                          }
                        }
                      },
                      [_vm._v("\n            Download Factsheet\n          ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "small-6 columns text-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "button button-small",
                    on: { click: _vm.onCreatePdf }
                  },
                  [_vm._v("\n            Drucken\n          ")]
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("h1", { staticClass: "no-margin" }, [
              _vm._v(
                "Keine Monatswerte für Index TrendPortfolio für " +
                  _vm._s(_vm.deadlines[_vm.deadline - 1].name) +
                  " vorhanden."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-left mt-3" }, [
              _vm.factsheet_path && _vm.factsheet_path[_vm.deadline]
                ? _c(
                    "a",
                    {
                      staticClass: "button button-small",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.onDownloadFactsheet(
                            _vm.factsheet_path[_vm.deadline]
                          )
                        }
                      }
                    },
                    [_vm._v("\n          Download Factsheet\n        ")]
                  )
                : _vm._e()
            ])
          ])
    ]),
    _vm._v(" "),
    _vm.lastConstituent
      ? _c("div", { staticClass: "row wrapper-spacing" }, [
          _c("div", { staticClass: "medium-12 large-12 columns" }, [
            _c("h1", [
              _vm._v(
                "Zusammensetzung der Anlageklassen TrendPortfolio Index " +
                  _vm._s(_vm.deadlines[_vm.deadline - 1].name)
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [
                _vm._v(
                  "Stand " +
                    _vm._s(
                      _vm.lastConstituent.month_name +
                        " " +
                        _vm.lastConstituent.year
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die für den angegebenen Monat ausgewählten Anlageklassen sind in rot dargestellt."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Die ausgewählten Anlageklassen gehen gleichgewichtet (zu je 25 %) in den Index ein. Falls weniger als vier Anlageklassen positive Trends aufzeigen und damit nicht in diesem Monat in den TrendPortfolio Index fließen, wird entsprechend weniger investiert."
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "spv-asset-classes" },
              [
                _vm._l(_vm.constituent_data[_vm.deadline], function(
                  item,
                  index
                ) {
                  return [
                    _c(
                      "div",
                      {
                        key: index,
                        staticClass: "small-12 medium-6 large-4 spv-card-widget"
                      },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "spv-card-widget__card",
                              { marked: item.weight === 25 }
                            ]
                          },
                          [_c("h2", [_vm._v(_vm._s(item.name))])]
                        )
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Indexstand"),
      _c("br"),
      _vm._v("jeweils am"),
      _c("br"),
      _vm._v("Ende des Monats")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon header-info" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27588454", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27588454","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/spv_trend.vue
// module id = ZfqX
// module chunks = 0